<template>
<div class="order-mode">
    <div class="table-number">{{$t("delivery.number_table", {number: this.$route.query.tableNum})}}</div>
    <div class="buffet" @click="selectMode(0)">
        <img src="../../../assets/order.png" alt="">
        <div class="title">{{ $t("checkout.default-order") }}</div>
    </div>
    <div class="order" @click="selectMode(1)">
        <img src="../../../assets/buffet.png" alt="">
        <div class="title">{{ $t("checkout.self-order") }}</div>
    </div>
</div>
</template>

<script>
export default {
    name: "order-mode",
    methods: {
        selectMode(buffet){
            if(window.tableIsNotExisted){
                return window.alert(this.$t("checkout.no-table"))
            }
            this.$emit('selectMode', buffet)
        }
    }
}
</script>

<style scoped lang="sass" src="./order-mode.sass"></style>